<div
  class="m-product-filter fixed top-0 left-0 z-50 flex h-screen w-full flex-col bg-white transition duration-[400ms] ease-in-out md:hidden"
  [ngClass]="isShowed ? 'translate-y-0' : 'translate-y-[100vh]'">
  <div class="header sticky top-0 flex items-center gap-3 border-b bg-white">
    <button class="p-3" (click)="toggleMenu()">
      <fa-icon [icon]="faTimes" class="text-xl text-gray-500"></fa-icon>
    </button>
    <h2 class="text-lg font-medium">Filter</h2>
  </div>
  <div class="filter-product mt-3 space-y-3 overflow-y-auto">
    <div class="filter-sort">
      <div
        class="card-header flex cursor-pointer items-center justify-between py-2 px-4">
        <h3 class="font-semibold">Sort</h3>
      </div>
      <div
        class="card-body space-y-3 py-3 px-4"
        style="transform-origin: center top">
        <div class="flex flex-wrap gap-3">
          <button
            *ngFor="let sort of sortList"
            class="rounded-full border py-1 px-3 text-sm"
            [ngClass]="{ 'bg-gray-100': sort.label == selectedSort.label }"
            (click)="setSelectedSort(sort)">
            {{ sort.label }}
          </button>
        </div>
      </div>
    </div>
    <div class="filter-brand">
      <div
        class="card-header flex cursor-pointer items-center justify-between py-2 px-4">
        <h3 class="font-semibold">Brand</h3>
      </div>
      <div
        class="card-body space-y-3 py-3 px-4"
        style="transform-origin: center top">
        <div class="flex flex-wrap gap-3">
          <button
            *ngFor="let brand of isShowAllBrands ? brands : brands.slice(0, 15)"
            class="rounded-full border py-1 px-3 text-sm"
            [ngClass]="{ 'bg-gray-100': checkedBrand(brand) }"
            (click)="onSelectBrand(brand)">
            {{ brand.name }}
          </button>
        </div>
        <button
          class="ml-auto block text-sm text-primary-darkest"
          (click)="isShowAllBrands = !isShowAllBrands">
          {{ isShowAllBrands ? 'Show less' : 'Show More' }}
        </button>
      </div>

      <p-skeleton *ngIf="!brands.length" class="h-2 w-full"></p-skeleton>
    </div>
    <div class="filter-price">
      <div
        class="card-header flex cursor-pointer items-center justify-between py-2 px-4">
        <h3 class="font-semibold">Price</h3>
      </div>
      <div class="card-body space-y-3 border-b p-3">
        <div class="p-inputgroup">
          <span class="p-inputgroup-addon">Rp</span>
          <p-inputNumber
            placeholder="Lowest Price"
            mode="decimal"
            locale="id-ID"
            [minFractionDigits]="2"
            [(ngModel)]="minPriceInput"
            (keyup)="onInputPrice()">
          </p-inputNumber>
        </div>
        <div class="p-inputgroup">
          <span class="p-inputgroup-addon">Rp</span>
          <p-inputNumber
            placeholder="Highest Price"
            mode="decimal"
            locale="id-ID"
            [minFractionDigits]="2"
            [(ngModel)]="maxPriceInput"
            (keyup)="onInputPrice()">
          </p-inputNumber>
        </div>
        <div class="quick-price space-y-3">
          <button
            type="button"
            class="btn btn-sm block rounded-full border py-1 px-3 text-gray-500 hover:text-gray-700"
            [ngClass]="{
              'bg-gray-100':
                quickPrice.minPrice == selectedPriceRange.minPrice &&
                quickPrice.maxPrice == selectedPriceRange.maxPrice
            }"
            *ngFor="let quickPrice of quickPrices"
            (click)="onQuickPrice(quickPrice.minPrice, quickPrice.maxPrice)">
            {{ quickPrice.label }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
